import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=8c3c932c&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "../../components/HostingPagesSidebar.scss?vue&type=style&index=0&id=8c3c932c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3c932c",
  null
  
)

export default component.exports